import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import {
  selectCollectionDetails,
  selectRegenerateCollectionPending,
  selectRegenerateImageCollectionPending,
  setSelectedExploreCollectionFilter,
  // selectToggleToFavoriteLoading,
  //   setSelectedCollection,
} from "../../store/slices/model/slice";
import {
  selectMuteVideo,
  setMuteVideo,
  // selectToggleToFavoriteLoading,
} from "../../store/slices/common/slice";
import {
  ModalContainer,
  Button,
  Buttons,
  CloseButton,
  VideoFooter,
  ModelName,
  VideoElement,
  //   ThumbnailVideo,
  VideoContainer,
  MessageButton,
  ModelSeed,
  FolderButton,
  SettingsButton,
  DownloadButton,
  MuteButton,
  DeleteButton,
  ButtonsRow,
  ButtonsColumn,
  VideoHeader,
  HeaderRow,
  ImageElement,
  ButtonText,
  ArrowButton,
  ArrowButtonWrapper,
  // FavoriteButton,
} from "./CollectionModal.styles";
// import { ReactComponent as MessageIcon } from "../../assets/icons/comment.svg";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { ReactComponent as WhiteStarSvg } from "../../assets/icons/whiteStar.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevronLeft.svg";
import { ReactComponent as FolderIcon } from "../../assets/icons/folder.svg";
import { ReactComponent as LeafIcon } from "../../assets/icons/leaf.svg";
import { ReactComponent as ThumbUpIcon } from "../../assets/icons/thumbs-up.svg";
import { ReactComponent as ThumbUpSelectedIcon } from "../../assets/icons/thumbs-up-selected.svg";
import { ReactComponent as ThumbDownIcon } from "../../assets/icons/thumbs-down.svg";
import { ReactComponent as ThumbDownSelectedIcon } from "../../assets/icons/thumbs-down-selected.svg";
import { ReactComponent as MutedIcon } from "../../assets/icons/muted.svg";
import { ReactComponent as UnmutedIcon } from "../../assets/icons/unmuted.svg";

// import { selectUser } from "../../store/slices/user/slice";
import { formatModelName, isImageOutput } from "../../utils/utils";
import {
  BLEND_MODEL,
  MEDIA_TYPE,
  NUDIFY_PRICE,
  REGENERATE_DISCOUNT_PERCENTAGE,
  VIDEO_DURATION_PRICE,
  VIDEO_FPS_PRICE,
  VIDEO_RESOLUTION_PRICE,
} from "../../utils/constants";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import {
  fetchCollection,
  regenerateCollection,
  regenerateBlendCollection,
  regenerateImageCollection,
  // toggleToFavorite,
} from "../../store/slices/model/asyncThunks";
import { toast } from "sonner";

// import likeAnimation from "../../assets/animations/like2.json";
import deleteAnimation from "../../assets/animations/trash.json";
import downloadAnimation from "../../assets/animations/download.json";
import LottieIcon from "../LottieIcon/LottieIcon";
import GenerationToast from "../utils/GenerationToast";
import { useNavigate } from "react-router-dom";
import ButtonAnimation from "../utils/ButtonAnimation";

const CollectionModal = ({
  isOpen,
  onClose,
  video,
  onDeleteClick,
  onRateClick,
  onFolderClick,
  onSettingsClick,
  setSettingsPrompt,
  setShowExtendVideoModal,
  rating,
  onNavigate,
  hasPrev,
  hasNext,
  navLoading,
}) => {
  useLockBodyScroll(isOpen);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const muteVideo = useSelector(selectMuteVideo);
  const [isMuted, setIsMuted] = useState(muteVideo);
  const hasAudio = Boolean(video?.audio);
  const { loading } = useSelector(selectCollectionDetails);

  // const loading = useSelector(selectToggleToFavoriteLoading);
  const regenerateLoading = useSelector(selectRegenerateCollectionPending);
  const regenerateLoading2 = useSelector(
    selectRegenerateImageCollectionPending,
  );

  const [aspectRatio, setAspectRatio] = useState("");

  const [isVerticalImage, setIsVerticalImage] = useState(true);

  // const user = useSelector(selectUser);

  const [inViewKey, setInViewKey] = useState(0);

  const { ref: videoContainerRef, inView } = useInView({
    threshold: 0.1,
    rootMargin: "100px",
    triggerOnce: true,
  });

  // Reset inView observer kad se video promeni
  useEffect(() => {
    setVideoLoaded(false);
    setInViewKey((prev) => prev + 1);
  }, [video?._id]);

  useEffect(() => {
    if (isOpen) {
      setIsMuted(hasAudio ? muteVideo : true);
    }
  }, [hasAudio, isOpen, muteVideo]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = hasAudio ? isMuted : true;
    }
  }, [hasAudio, isMuted]);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft" && hasPrev && !navLoading) {
        onNavigate(-1);
      } else if (e.key === "ArrowRight" && hasNext && !navLoading) {
        onNavigate(1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, hasPrev, hasNext, navLoading, onNavigate]);

  useEffect(() => {
    let width =
      video?.input?.image?.resizedImage?.width || video?.input?.image?.width;
    let height =
      video?.input?.image?.resizedImage?.height || video?.input?.image?.height;

    if (width && height) {
      setAspectRatio(`${width} / ${height}`);
      setIsVerticalImage(width <= height);
      return;
    }

    if (video?.output?.type === MEDIA_TYPE.IMAGE && video?.output?.image?.url) {
      const img = new Image();
      img.onload = () => {
        setAspectRatio(`${img.naturalWidth} / ${img.naturalHeight}`);
        setIsVerticalImage(img.naturalWidth <= img.naturalHeight);
      };
      img.src = video.output.image.url;
    } else if (
      video?.output?.type === MEDIA_TYPE.VIDEO &&
      video?.output?.video?.url
    ) {
      const videoEl = document.createElement("video");
      videoEl.onloadedmetadata = () => {
        setAspectRatio(`${videoEl.videoWidth} / ${videoEl.videoHeight}`);
        setIsVerticalImage(videoEl.videoWidth <= videoEl.videoHeight);
      };
      videoEl.src = video.output.video.url;
    }
  }, [video]);

  // const handleFavoriteToggle = () => {
  //   if (!loading && video._id) {
  //     dispatch(toggleToFavorite({ collectionId: video._id }));
  //   }
  // };

  const handleVideoLoad = () => {
    setVideoLoaded(true);
  };

  const handleToggleMute = () => {
    if (!hasAudio) {
      return;
    }

    const nextMutedState = !isMuted;
    setIsMuted(nextMutedState);
    dispatch(setMuteVideo(nextMutedState));
  };

  const handleDeleteClick = () => {
    if (onDeleteClick) {
      onDeleteClick();
    }
  };

  const handleRateClick = (rating) => {
    if (onRateClick) {
      onRateClick(rating);
    }
  };

  const handleFolderClick = () => {
    if (onFolderClick) {
      onFolderClick();
    }
  };

  const handleSettingsClick = () => {
    if (onSettingsClick) {
      onSettingsClick();
      setSettingsPrompt(video?.customPrompt);
    }
  };

  const handleDownload = async () => {
    let mediaUrl = null;
    if (video.output.type === MEDIA_TYPE.IMAGE) {
      mediaUrl = video.output.image.url;
    } else {
      mediaUrl = video.output.video.url;
    }

    if (!mediaUrl) return;

    window.location.href = mediaUrl;
    return;
  };

  const regenerateVideo = () => {
    if (BLEND_MODEL === video.modelType) {
      dispatch(
        regenerateBlendCollection({
          collectionId: video._id,
          seed: Math.floor(Math.random() * 10000000) + 1,
        }),
      )
        .unwrap()
        .then(() => {
          <GenerationToast
            successMessage={"Regeneration started.."}
            label="View"
            onClick={() => {
              navigate("/collection");

              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
              });
            }}
          />;
          onClose();
        })
        .catch((err) => {
          toast.error(err);
        });
    } else if (isImageOutput(video.modelType)) {
      dispatch(
        regenerateImageCollection({
          collectionId: video._id,
          seed: Math.floor(Math.random() * 10000000) + 1,
        }),
      )
        .unwrap()
        .then(() => {
          <GenerationToast
            successMessage={"Regeneration started.."}
            label="View"
            onClick={() => {
              navigate("/collection");

              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
              });
            }}
          />;
          onClose();
        })
        .catch((err) => {
          toast.error(err);
        });
    } else {
      dispatch(
        regenerateCollection({
          collectionId: video._id,
          seed: Math.floor(Math.random() * 10000000) + 1,
        }),
      )
        .unwrap()
        .then(() => {
          <GenerationToast
            successMessage={"Regeneration started.."}
            label="View"
            onClick={() => {
              navigate("/collection");

              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
              });
            }}
          />;
          onClose();
        })
        .catch((err) => {
          toast.error(err);
        });
    }
  };

  const copyToClipBoard = async () => {
    if (video.seed) {
      try {
        await navigator.clipboard.writeText(video.seed);
        toast.success("Copied to clipboard");
      } catch (err) {
        console.error("Failed to copy link:", err);
      }
    }
  };

  if (!video) return null;

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        customOverlayStyles={{ zIndex: 3000 }}
      >
        <ModalContainer
          ref={videoContainerRef}
          key={inViewKey}
          $aspectRatio={aspectRatio}
          $minHeight={!!video?.customPrompt ? "415px" : "371px"}
        >
          <ArrowButtonWrapper
            onClick={() => hasPrev && !navLoading && onNavigate(-1)}
            style={{
              opacity: hasPrev ? 1 : 0.3,
              //   pointerEvents: hasPrev && !navLoading ? "auto" : "none",
            }}
          >
            <ArrowButton>
              {navLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
              ) : (
                <ChevronIcon />
              )}
            </ArrowButton>
          </ArrowButtonWrapper>

          <ArrowButtonWrapper
            $right
            onClick={() => hasNext && !navLoading && onNavigate(1)}
            style={{
              opacity: hasNext ? 1 : 0.3,
              //   pointerEvents: hasNext && !navLoading ? "auto" : "none",
            }}
          >
            <ArrowButton>
              {navLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
              ) : (
                <ChevronIcon style={{ rotate: "180deg" }} />
              )}
            </ArrowButton>
          </ArrowButtonWrapper>
          <VideoHeader>
            <HeaderRow>
              <ModelName>{formatModelName(video?.name)}</ModelName>

              <CloseButton onClick={onClose}>
                <CloseSvg />
              </CloseButton>
            </HeaderRow>
            {!!video.seed && (
              <ModelSeed onClick={copyToClipBoard}>
                <LeafIcon />
                {video.seed}
              </ModelSeed>
            )}
          </VideoHeader>

          <VideoContainer>
            {video?.output?.type === MEDIA_TYPE.IMAGE ? (
              <ImageElement
                src={video.output.image.url}
                $isVerticalImage={isVerticalImage}
              />
            ) : (
              <>
                {/* <ThumbnailVideo
                  src={
                    video?.input?.image?.resizedImage?.url ||
                    video?.input?.image?.url
                  }
                  alt={video?.modelName || "Video thumbnail"}
                  $loaded={videoLoaded}
                  $blur={!videoLoaded}
                /> */}
                {inView && (
                  <VideoElement
                    ref={videoRef}
                    controls={false}
                    onLoadedData={handleVideoLoad}
                    muted={hasAudio ? isMuted : true}
                    loop
                    playsInline
                    poster={
                      video?.input?.image?.resizedImage?.url ||
                      video?.input?.image?.url
                    }
                    autoPlay
                    preload="auto"
                    $loaded={videoLoaded}
                    $isVerticalImage={isVerticalImage}
                  >
                    <source
                      src={
                        video?.output?.video?.compressedUrl ||
                        video?.output?.video?.url
                      }
                      type="video/mp4"
                    />
                  </VideoElement>
                )}
              </>
            )}
          </VideoContainer>

          <VideoFooter>
            <ButtonsRow>
              <ButtonsColumn>
                {!!video?.customPrompt && (
                  <SettingsButton onClick={() => {}}>
                    <ButtonAnimation
                      variant="settings"
                      color="167, 139, 250"
                      onAnimate={handleSettingsClick}
                    >
                      <SettingsIcon
                        width={18}
                        height={18}
                        style={{ marginTop: 2 }}
                      />
                    </ButtonAnimation>
                  </SettingsButton>
                )}

                <FolderButton onClick={() => {}}>
                  <ButtonAnimation
                    variant="folder"
                    color="251, 191, 36"
                    onAnimate={handleFolderClick}
                  >
                    <FolderIcon
                      width={18}
                      height={18}
                      style={{ marginTop: 2 }}
                    />
                  </ButtonAnimation>
                </FolderButton>

                <MessageButton $ratingUp={rating === 1} onClick={() => {}}>
                  <ButtonAnimation
                    variant="thumb"
                    color="40, 217, 96"
                    isActive={rating === 1}
                    onAnimate={() => rating !== 1 && handleRateClick(1)}
                  >
                    {rating === 1 ? (
                      <ThumbUpSelectedIcon width={18} height={18} />
                    ) : (
                      <ThumbUpIcon width={18} height={18} />
                    )}
                  </ButtonAnimation>
                </MessageButton>

                <MessageButton $ratingDown={rating === -1} onClick={() => {}}>
                  <ButtonAnimation
                    variant="thumb"
                    color="255, 89, 89"
                    isActive={rating === -1}
                    onAnimate={() => rating !== -1 && handleRateClick(-1)}
                  >
                    {rating === -1 ? (
                      <ThumbDownSelectedIcon
                        width={18}
                        height={18}
                        style={{ marginTop: 3 }}
                      />
                    ) : (
                      <ThumbDownIcon
                        width={18}
                        height={18}
                        style={{ marginTop: 3 }}
                      />
                    )}
                  </ButtonAnimation>
                </MessageButton>
                <DownloadButton
                  style={{ whiteSpace: "nowrap" }}
                  onClick={handleDownload}
                >
                  <LottieIcon
                    animationData={downloadAnimation}
                    trigger="click"
                    size={22}
                    absolute
                  />
                </DownloadButton>
              </ButtonsColumn>
              <ButtonsColumn>
                {video?.output?.type === MEDIA_TYPE.VIDEO && hasAudio && (
                  <MuteButton onClick={handleToggleMute}>
                    {isMuted ? (
                      <MutedIcon width={18} height={18} />
                    ) : (
                      <UnmutedIcon width={18} height={18} />
                    )}
                  </MuteButton>
                )}
                <DeleteButton onClick={handleDeleteClick}>
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    style={{ bottom: 10 }}
                    size={22}
                    absolute
                    strokeColor={"#FF8787"}
                  />
                </DeleteButton>
              </ButtonsColumn>
            </ButtonsRow>

            <Buttons>
              {video?.output?.type === MEDIA_TYPE.VIDEO && (
                <Button
                  disabled={regenerateLoading || regenerateLoading2 || loading}
                  onClick={() => {
                    dispatch(setSelectedExploreCollectionFilter("EXTEND_WITH"));
                    dispatch(fetchCollection({ collectionId: video._id }))
                      .unwrap()
                      .then(() => {
                        setShowExtendVideoModal(true);
                      })
                      .catch(() => {
                        setShowExtendVideoModal(true);
                      });
                  }}
                >
                  <ButtonText>Extend Video</ButtonText>
                  {loading ? (
                    <l-line-spinner
                      size="16"
                      stroke="1.5"
                      speed="1"
                      color="#fff"
                    />
                  ) : (
                    <>
                      <WhiteStarSvg width={14} height={14} />
                      <ButtonText>30</ButtonText>
                    </>
                  )}
                </Button>
              )}
              {video?.output?.type === MEDIA_TYPE.IMAGE && (
                <Button
                  disabled={regenerateLoading || regenerateLoading2 || loading}
                  onClick={() => {
                    dispatch(setSelectedExploreCollectionFilter("EXTEND_WITH"));
                    dispatch(fetchCollection({ collectionId: video._id }))
                      .unwrap()
                      .then(() => {
                        setShowExtendVideoModal(true);
                      })
                      .catch(() => {
                        setShowExtendVideoModal(true);
                      });
                  }}
                >
                  <ButtonText>Animate</ButtonText>
                  {loading ? (
                    <l-line-spinner
                      size="16"
                      stroke="1.5"
                      speed="1"
                      color="#fff"
                    />
                  ) : (
                    <>
                      <WhiteStarSvg width={14} height={14} />
                      <ButtonText>30</ButtonText>
                    </>
                  )}
                </Button>
              )}

              <Button
                disabled={regenerateLoading || regenerateLoading2 || loading}
                onClick={regenerateVideo}
              >
                {regenerateLoading || regenerateLoading2 ? (
                  <l-line-spinner size="16" stroke="2" speed="1" color="#fff" />
                ) : (
                  <>
                    <ButtonText>Generate Again</ButtonText>
                    <WhiteStarSvg width={14} height={14} />
                    <ButtonText>
                      {isImageOutput(video.modelType)
                        ? Math.ceil(
                            video.price * (1 - REGENERATE_DISCOUNT_PERCENTAGE),
                          )
                        : Math.ceil(
                            (video.price +
                              (video.nudify ? NUDIFY_PRICE : 0) +
                              VIDEO_RESOLUTION_PRICE[video.output.resolution] +
                              (VIDEO_DURATION_PRICE[
                                video.output.videoDuration
                              ] ?? 0) +
                              (VIDEO_FPS_PRICE[video.output.fps] ?? 0)) *
                              (1 - REGENERATE_DISCOUNT_PERCENTAGE),
                          )}
                    </ButtonText>
                  </>
                )}
              </Button>
            </Buttons>
          </VideoFooter>
        </ModalContainer>
      </Modal>
    </>
  );
};

export default CollectionModal;
